import { Component, Inject, ViewChild, HostListener } from "@angular/core";
import { AppService } from "./app.service";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { JWTTokenService } from "./app.jwt-token.service";
import { gitTag } from "src/environments/version";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { MatButtonModule } from "@angular/material/button";
import { MatSidenav } from '@angular/material/sidenav';
import { PlanGateService } from './services/plan-gate.service';
import { SITE_LINKS } from './site-links';


@Component({
  selector: "app-root",
  standalone: false,
  templateUrl: "./app.component.html",
  styleUrls: [
    "./app.component.css"
  ],
})

export class AppComponent {

  textContent: any;
  emailId: any;
  userName: any;
  amountValue: any;
  isAmountValid: boolean = false;
  opened: boolean = false;
  currentRoute = "";
  showDefaultMenu: boolean = true;
  image: string = '';
  isAgentRoute: boolean = false;
  workspaces: any = [];
  selected: any;
  selectedWid: any;
  wsName: any;
  apiKey: any;
  status: any;
  csummery: any;
  workspaceName: string | null = null;
  sharedArray: any[] = [];
  usersExpanded: boolean = false;
  usersList: any[] = [];

  isMobile: boolean = false;
  readonly links = SITE_LINKS;
  @ViewChild('drawer') drawer!: MatSidenav;

  // lworkspaces: string[] = [];

  constructor(
    public router: Router,
    public dialog: MatDialog,
    public jwtservice: JWTTokenService,
    public appService: AppService,
    private http: HttpClient,
    private route: ActivatedRoute,
    public planGate: PlanGateService
  ) {

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Strip query string so route guards (e.g. hiding the sidenav on /login)
        // still match when links add params like /login?scrollTo=features
        this.currentRoute = this.router.url.split('?')[0];
        this.appService.set('xdbc.lastUrl', this.router.url);

        // Close sidenav on route change on mobile
        if (this.isMobile && this.appService.opened) {
          this.closeSideNav();
        }

        this.checkAndNavigateToChat();
      }
    });

  }




  getWorkspace() {
    let obj: any = {
      userId: 1,
      email: this.appService.get('xdbc.emailId')
    }
    try {
      this.appService.postRequest(obj, "auth/list-workspace").then(res => {
        this.workspaces = res.data;
        let dwork = this.workspaces.filter((de: any) => de.default);

        this.appService.set('xdbc.workspace', JSON.stringify(dwork[0]));
        this.appService.workspaceName = dwork[0].workspaceName;
      });
    } catch (error) {
      console.error('Error fetching files', error);
    }
  }

  setDefault(id: any) {

    let obj: any = {
      workspaceId: id,
      email: this.appService.get('xdbc.emailId')
    }
    try {
      this.appService.postRequest(obj, "auth/set-default-workspace").then(res => {
        this.workspaces = res.data;
        this.appService.set('xdbc.workspace', JSON.stringify(res.data));
        this.getWorkspace()
      });
    } catch (error) {
      console.error('Error fetching files', error);
    }

  }



  ngOnInit(): void {

    this.detectMobile();

    // The route guard loads this on navigation, but a direct landing on an
    // always-open route (e.g. /subscription) would otherwise never check.
    this.planGate.ensureLoaded();

    this.appService.workspaces$.subscribe(data => {
      this.workspaces = data;
    });

    const wsJson = this.appService.get("xdbc.workspace");
    if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
      try {
        const ws = JSON.parse(wsJson);
        this.appService.workspaceName = ws.workspaceName;
      } catch (err) {
        console.error('Invalid JSON:', err);
      }
    }

    // this.getWorkspace();    
  }

  detectMobile() {
    this.isMobile = window.innerWidth <= 768;
    if (this.isMobile) {
      this.appService.opened = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.detectMobile();
  }

  async checkAndNavigateToChat(): Promise<void> {
    // Check if this is a fresh login (has workspace but hasn't navigated yet)
    const justLoggedIn = this.appService.get('xdbc.justLoggedIn');
    if (justLoggedIn !== 'true') {
      return;
    }

    // Only proceed if on workspace page or login page
    // This allows the check to run after login component navigates to workspace
    if (!this.currentRoute.includes('/workspace') && this.currentRoute !== '/login') {
      return;
    }

    try {
      // Get workspace details
      const wsJson = this.appService.get("xdbc.workspace");
      if (!wsJson || wsJson === 'undefined') {
        return;
      }

      let apiKey: string, workspaceName: string;
      try {
        const ws = JSON.parse(wsJson);
        apiKey = ws.apiKey;
        workspaceName = ws.workspaceName;
      } catch (err) {
        console.error('Invalid JSON:', err);
        return;
      }

      // Get default user
      const defaultUser = await this.getDefaultUser(apiKey, workspaceName);

      if (defaultUser && defaultUser.userkey) {
        // Clear the flag before navigating
        this.appService.remove('xdbc.justLoggedIn');

        // Set a flag to show welcome message in chat component
        this.appService.set('xdbc.showWelcomeMessage', 'true');

        // Navigate to chat with default user
        this.router.navigate(['/chat/' + defaultUser.userkey]);
      } else {
        // No default user found, clear the flag
        this.appService.remove('xdbc.justLoggedIn');
      }
    } catch (error) {
      console.error('Error in checkAndNavigateToChat:', error);
      // Clear flag on error
      this.appService.remove('xdbc.justLoggedIn');
    }
  }

  async getDefaultUser(apiKey: string, workspaceName: string): Promise<any> {
    try {
      const activationPayload = {
        routeType: "UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/list-profile",
        apiKey,
        signature,
      );

      if (response && response.status == "Success" && response.data?.profiles) {
        const profiles = response.data.profiles;

        // Find default user or return first user
        const defaultUser = profiles.find((profile: any) => profile.default === true);
        return defaultUser || profiles[0];
      }

      return null;
    } catch (error: any) {
      console.error('Error fetching default user:', error);
      return null;
    }
  }

  // routeUrl(route:string){

  //     if(route === "users"){
  //       this.router.navigate(['/users']);
  //     } else if (route === "interactions"){
  //       this.router.navigate(['/interactions']);
  //     } else if (route === "memories"){ 
  //       this.router.navigate(['/memories']);
  //     } else if (route === "reminders"){
  //       this.router.navigate(['/reminders']);
  //     }    

  // }

  openedSideNav() {
    if (!this.appService.takeawayFeatureRestriction) {
      this.appService.opened = false;
    } else {
      this.appService.opened = true;
    }
  }

  getMenuNav() {
    if (!this.appService.takeawayFeatureRestriction) {
      this.appService.opened = false;
    }
  }



  openSearchDialog(): void {
    this.router.navigate(['/search']);
  }

  toggleUsersMenu() {
    this.usersExpanded = !this.usersExpanded;
    if (this.usersExpanded && this.usersList.length === 0) {
      this.getUsersList();
    }
  }

  async getUsersList() {
    try {
      const wsJson = this.appService.get("xdbc.workspace");
      let apiKey, workspaceName;

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          apiKey = ws.apiKey;
          workspaceName = ws.workspaceName;
        } catch (err) {
          console.error('Invalid JSON:', err);
          return;
        }
      }

      const activationPayload = {
        routeType: "UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/list-profile",
        apiKey,
        signature,
      );

      if (response && response.status == "Success") {
        this.usersList = response?.data?.profiles || [];
      }
    } catch (error: any) {
      console.error('Error fetching users:', error);
    }
  }

  routeUserAction(userkey: string, action: string) {
    if (this.isMobile) {
      setTimeout(() => {
        this.closeSideNav();
      }, 300);
    }

    switch (action) {
      case 'dashboard':
        this.router.navigate(['/user-dashboard/' + userkey]);
        break;
      case 'memory':
        this.router.navigate(['/memories/' + userkey]);
        break;
      case 'recipe':
        this.router.navigate(['/recipe/' + userkey]);
        break;
      case 'receipt':
        this.router.navigate(['/receipt/' + userkey]);
        break;
      case 'nutrition':
        this.router.navigate(['/nutrition/' + userkey]);
        break;
      case 'reminder':
        this.router.navigate(['/reminders/' + userkey]);
        break;
      case 'chat':
        this.router.navigate(['/chat/' + userkey]);
        break;
    }
  }

  openSideNav() {
    this.appService.set('menuvisible', 'true');
    this.appService.opened = true;  // ✅ OPENS menu

    // Prevent body scroll on mobile
    if (this.isMobile) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
  }

  closeSideNav() {
    this.appService.set('menuvisible', 'false');
    this.appService.opened = false;  // ✅ CLOSES menu

    // Re-enable body scroll
    if (this.isMobile) {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
  }


  // logOut() {
  //   this.appService.logOut();
  // }

  async logOut() {
    this.planGate.clear();
    await this.appService.logOut()
      .then(() => {
        console.log('Calling handleTokenInvalidation from AppComponent...');
        return Promise.resolve(this.jwtservice.handleTokenInvalidation());
      })
      .then(() => {
        console.log('handleTokenInvalidation finished from AppComponent...');
        return Promise.resolve(this.jwtservice.clearTokenExpirationCheck());
      })
      .then(() => {
        console.log('signOut finished from AppComponent...');
      });

    this.appService.remove('xdbc.lastUrl');
  }


  buildTime: any = gitTag.buildTime;
  commitID: any = gitTag.commitId;
  uiVersion: string = gitTag.version;
  version: any;

  getVersion() {
    let count = this.uiVersion.split("-").length - 1;
    if (count === 2) {
      this.version = this.uiVersion.split("-", 2).join("-");
    } else if (count === 1) {
      this.version = this.uiVersion.split("-", 1).join("-");
    }
  }



  async goToChat() {
    if (this.isMobile) {
      this.closeSideNav();
    }

    try {
      const wsJson = this.appService.get("xdbc.workspace");
      if (!wsJson || wsJson === 'undefined') {
        // No workspace set, navigate to workspace page
        this.router.navigate(['/workspace']);
        return;
      }

      let apiKey: string, workspaceName: string;
      try {
        const ws = JSON.parse(wsJson);
        apiKey = ws.apiKey;
        workspaceName = ws.workspaceName;
      } catch (err) {
        console.error('Invalid JSON:', err);
        this.router.navigate(['/workspace']);
        return;
      }

      // Get default user
      const defaultUser = await this.getDefaultUser(apiKey, workspaceName);

      if (defaultUser && defaultUser.userkey) {
        this.router.navigate(['/chat/' + defaultUser.userkey]);
      } else {
        // No users found, navigate to users page to create one
        this.router.navigate(['/users']);
      }
    } catch (error) {
      console.error('Error navigating to chat:', error);
      this.router.navigate(['/users']);
    }
  }


}

// @Component({
//   selector: 'dialog-privacy-policy',
//   templateUrl: './privacy-policy/privacy-policy.component.html',
//   imports: [MatDialogModule, MatButtonModule],  
// })
// export class PrivacyPolicyDialog {}